export default __webpack_public_path__ + "img/dvUuJZoe.a2677c5d.svg";